/** @jsxImportSource @emotion/react */
"use client";

import { useAB } from "@packages/ab";
import type { ReactNode } from "react";

import { LoadingWrapper } from "./LoadingWrapper.emotion";

export type LoadingWrapperABProps = {
  children: ReactNode;
};

export const LoadingWrapperAB = ({ children }: LoadingWrapperABProps) => {
  const { isLoading } = useAB();
  return <LoadingWrapper isLoading={isLoading}>{children}</LoadingWrapper>;
};
